import { h } from '../../../utils/dom.js';

export function RingProgress({ percent, color, label }) {
  const r = 50, circ = 2 * Math.PI * r;
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 120 120');

  const track = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  track.setAttribute('class', 'ring-track');
  track.setAttribute('cx', '60'); track.setAttribute('cy', '60'); track.setAttribute('r', String(r));
  svg.appendChild(track);

  const val = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  val.setAttribute('class', 'ring-val');
  val.setAttribute('cx', '60'); val.setAttribute('cy', '60'); val.setAttribute('r', String(r));
  val.style.stroke = color;
  val.setAttribute('stroke-dasharray', String(circ));
  val.setAttribute('stroke-dashoffset', String(circ));
  svg.appendChild(val);

  const wrap = h('div', { class: 'ring-wrap' },
    svg,
    h('div', { class: 'ring-center' }, h('span', { class: 'ring-num' }, `${percent}%`)),
  );

  // Animate after mount
  requestAnimationFrame(() => {
    val.style.strokeDashoffset = String(circ - (percent / 100) * circ);
  });

  return h('div', { class: 'ring-block' }, wrap, h('div', { class: 'ring-label' }, label));
}